module.exports = __webpack_public_path__ + "img/陆港钢铁.caab7adb.png";